import { size } from '@op/util'
import type { FieldValidator } from 'final-form'

export const maxLength =
	(errorText: string, max: number): FieldValidator<string> =>
	(value) =>
		size(value) <= max ? undefined : errorText
